export const chargeServiceMatrixConstants = {
    CHARGE_MATRIX_FETCHING: 'CHARGE_MATRIX_FETCHING',
    CHARGE_MATRIX_FETCHED: 'CHARGE_MATRIX_FETCHED',
    GET_CHARGE_SERVICE_MATRIX: 'GET_CHARGE_SERVICE_MATRIX',
    GET_CHARGE_SERVICE_MATRIX_BY_ID: 'GET_CHARGE_SERVICE_MATRIX_BY_ID',
    UPDATE_CHARGE_SERVICE_MATRIX: 'UPDATE_CHARGE_SERVICE_MATRIX',
    SEARCH_CHARGE_SERVICE_MATRIX: 'SEARCH_CHARGE_SERVICE_MATRIX',
    GET_FULL_CHARGE_SERVICE_MATRIX: 'GET_FULL_CHARGE_SERVICE_MATRIX'
}